import React from "react";

export const SelectBox = ({
  Label,
  name,
  register,
  errors,
  defaultValue,
  validationRules,
  watch,
  children,
  onChange,
  disabled = false,
  ...rest
}) => {
  const value = watch(name);
  const isRequired = validationRules?.required;
  const { onChange: reactHookFormOnChange, ...restRegister } = register(
    name,
    validationRules
  );
  const { style, wrapperClassName = "mb-4", ...restProps } = rest;

  return (
    <div className={wrapperClassName}>
      {Label && (
        <label className="block mb-2 text-sm font-bold text-gray-700">
          {Label} {isRequired && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        <select
          disabled={disabled}
          defaultValue={defaultValue}
          className={`w-full px-4 py-2 text-base bg-white border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-all duration-200 disabled:bg-gray-100 disabled:cursor-not-allowed
                ${errors[name] ? 'border-red-500 focus:ring-red-200' : ''}
                ${!errors[name] && value && !disabled ? 'border-green-500' : ''}
            `}
          style={{
            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23f59e0b' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e")`,
            backgroundPosition: `right 0.75rem center`,
            backgroundRepeat: `no-repeat`,
            backgroundSize: `16px 12px`
          }}
          {...register(name, validationRules)}
          onChange={(e) => {
            reactHookFormOnChange(e);
            if (onChange) onChange(e);
          }}
          {...restProps}
        >
          {children}
        </select>
      </div>
      {errors[name] && (
        <div className="text-red-500 text-xs mt-1">
          {errors[name].message}
        </div>
      )}
    </div>
  );
};
